// extracted by mini-css-extract-plugin
export var button = "add-plan-template-modal-module--button--5ed3a";
export var checkboxes = "add-plan-template-modal-module--checkboxes--4a84f";
export var checkboxesLabel = "add-plan-template-modal-module--checkboxes-label--89b73";
export var checkboxesRow = "add-plan-template-modal-module--checkboxes-row--841e4";
export var form = "add-plan-template-modal-module--form--d1792";
export var input = "add-plan-template-modal-module--input--61fc9";
export var loader = "add-plan-template-modal-module--loader--2e6ea";
export var modal = "add-plan-template-modal-module--modal--01239";
export var separator = "add-plan-template-modal-module--separator--3375d";